import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { InputTextarea } from 'primereact/inputtextarea';

import { updateSection } from '../../actions/main.action';
import { ContainerTemplate } from '../../components/core-components/templates/container.template';
import { updateCars } from '../../slices/main-content.slice';
import { useAppDispatch, useAppSelector } from '../../store/store';

export const CarsContentPage = () => {
  const dispatch = useAppDispatch();

  const { cars } = useAppSelector(({ main }) => main.sections);

  const handleUpdateCarsContent = (key: string, value: string) => {
    dispatch(updateCars({ ...cars, [key]: value }));
  };

  const handleSaveBanner = () => {
    dispatch(updateSection({ section: cars }));
  };

  return (
    <ContainerTemplate>
      <Card title="Контент страницы машин" className={'border-2 border-yellow'}>
        <div>
          <label htmlFor="headline">Заголовок</label>
          <InputTextarea
            className={'w-full'}
            id="headline"
            value={cars.title ?? ''}
            onChange={({ target }) => handleUpdateCarsContent('title', target.value)}
          />
        </div>
        <div className="mt-2">
          <label htmlFor="description">Описание</label>
          <InputTextarea
            className={'w-full'}
            id="description"
            value={cars.description ?? ''}
            onChange={({ target }) => handleUpdateCarsContent('description', target.value)}
          />
        </div>
        <Button
          label="Сохранить"
          icon="pi pi-check"
          className={'mt-2'}
          onClick={handleSaveBanner}
        />
      </Card>
    </ContainerTemplate>
  );
};
